export default __webpack_public_path__ + "static/media/discover.e5d1b6a2.svg";